(function() {
	'use strict';

	angular
		.module('qbePortal')
		.service('paymentLoggerService', paymentLoggerService);

	paymentLoggerService.$inject = [
		'$log',
		'$http',
		'Util',
		'quoteModelFactory',
		'MODULE_INFO',
		'storage'
	];
	function paymentLoggerService(
		$log,
		$http,
		util,
		quoteModelFactory,
		MODULE_INFO,
		storage
	) {
		this.trackQuoteStatus = trackQuoteStatus;
		var endpoint = '/api/QuoteAndBuyLog/QuoteAndBuyLogger'; // put sitecore endpoint here

		function trackQuoteStatus(serviceCallStatus, nextStep, response) {
			var processData = {};
			try {
				if (MODULE_INFO.id === 'payments') {
					var referenceNumber = util.b64DecodeUnicode(
						storage.getItem('unauth-reference')
					);
					processData = {
						quoteId: referenceNumber,
						currentService: serviceCallStatus,
						nextService: nextStep,
						response: JSON.stringify(response)
					};
				} else {
					var quoteModel = quoteModelFactory.create(),
						quoteId = quoteModel.quoteId;
					processData = {
						quoteId: quoteId,
						currentService: serviceCallStatus,
						nextService: nextStep,
						response: JSON.stringify(response)
					};
				}
				$log.log(processData);
				sendLogs(processData);
			} catch (error) {
				$log.log(error);
			}
		}

		function sendLogs(processData) {
			var req = {
				method: 'POST',
				url: endpoint,
				data: processData
			};

			$http(req).then(
				function() {
					$log.log('successfully called the logger API');
				},
				function(error) {
					$log.log(error.status + ' : ' + error.statusText);
				}
			);
		}
	}
})();
